export const optimization = {
  name: "optimization" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 3.818a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4.141a4.141 4.141 0 1 0 0 8.282 4.141 4.141 0 0 0 0-8.282ZM6.04 12a5.96 5.96 0 1 1 11.92 0 5.96 5.96 0 0 1-11.92 0Zm5.96-.101a.101.101 0 1 0 0 .202.101.101 0 0 0 0-.202ZM10.08 12a1.92 1.92 0 1 1 3.84 0 1.92 1.92 0 0 1-3.84 0Z" clip-rule="evenodd"/></svg>`,
  keywords: ["optimization"],
  category: "other" as const,
};
